import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { CanActivate } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor( protected auth: AuthService ) {
        
    }
    
    
    canActivate(){
        if (this.auth.isAuthenticated())
            return true;

        else{
            this.auth.login();
            return false;
        }
    
     
   }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/auth-guard.service.ts